// Beta chip for a page header — driven by the module catalog served in
// /api/config. Tier membership stays in the catalog for server-side
// enforcement but is deliberately NOT badged in the UI (UAT ruling
// 2026-07-16: menu and pages stay clean; Beta is the only user-facing flag).

import type { PageModule } from '@/lib/usePages';
import { messageClass } from '@/components/ui/Message';
import { cn } from '@/lib/utils';

export function BetaBadge({ pm }: { pm: PageModule | undefined }) {
  if (!pm?.beta) return null;
  return (
    <span
      title="Beta — recently shipped, still hardening"
      className={cn(messageClass('platform', 'compact', 'warning'), 'rounded-full px-1.5 py-px text-[10px] leading-4 ml-2 inline-flex items-center align-middle font-medium leading-4')}
    >
      Beta
    </span>
  );
}
